import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'linkifyFormat',
})
export class LinkifyFormatPipe implements PipeTransform {

    transform(link: string): string {
        return this.linkify(link)
    }

    private linkify(plainText): string {
        let replacedText
        let replacePattern1
        let replacePattern2
        let replacePattern3
        if (plainText !== undefined) {
            replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
            replacedText = plainText.replace(replacePattern1, function replacer($1, $2, $3) {
                let url: any = $1
                let urlClean
                if (url) {
                    const len = url.length
                    if (len > 30) {
                        urlClean = url.substr(0, 21) + '...' + url.substring(len - 9, len)
                    } else {
                        urlClean = url
                    }
                } else {
                    urlClean = url
                }
                return '<a href="' + url + '" target="_blank">' + urlClean + '</a>'
            })

            replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim
            replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')

            replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim
            replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>')
            return replacedText
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pipes/linkify-format.pipe.ts